module.exports = require("./mi.d.ts");